import React from 'react';
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { currencyFormat } from '../../js/Functions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleLeft, faAngleDoubleRight, faAngleLeft, faAngleRight, faEdit, faFileInvoiceDollar, faFilter, faHandHoldingUsd, faPlus, faTrashAlt } from '@fortawesome/free-solid-svg-icons';

class Listar extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        load: '',
        facturas: []
    }

    ListarFacturas(page) {
        Swal.showLoading();
        let btype = document.getElementById('btype').value;
        let bname = document.getElementById('bname').value;
        if (btype == '') {
            btype = 0;
        }
        if (bname == '') {
            bname = 0;
        }
        authAxios.get("facturas/index/" + btype + "/" + bname + "?page=" + page)
            .then((dataResult) => {
                console.log(dataResult);
                Swal.close();
                var status = dataResult.data.status;
                if (!status) {
                    Swal.fire('Token has Expired!', 'Re-Login', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({
                    facturas: dataResult.data.facturas.data,
                    page: dataResult.data.facturas.total,
                    last: dataResult.data.facturas.last_page,
                    current: dataResult.data.facturas.current_page
                });
            })
            .catch(console.log);
    }
    componentDidMount() {
        this.ListarFacturas(1);
    }
    render() {
        const { load, facturas, page, last, current } = this.state;
        return (
            <div className="content">
                <div className="container-fluid">
                    <br/>
                    <div className="card">
                        <div className="card-header">
                            <Link className="btn btn-success btn-sm" to={"/AddFacturas"}><FontAwesomeIcon icon={faFileInvoiceDollar} />&nbsp;&nbsp;Generar Factura</Link>
                        </div>
                        <div className="card-body">
                            <h4>Lista de Facturas</h4>
                            <hr />
                            <div className="row">
                                <div className="col-xl-2">
                                    <select name="btype" id="btype"
                                        className={"form-select form-select-sm"}>
                                        <option value="">-</option>
                                        <option value="1">PACIENTE</option>
                                        <option value="2">IDENTIFICACIÓN</option>
                                    </select>
                                </div>
                                <div className="col-xl-4">
                                    <input style={{ textTransform: 'uppercase' }} type="text" id="bname" name="bname" placeholder="Buscar Paciente" className="form-control form-control-sm" />
                                </div>
                                <div className="col-xl-3">
                                    <button id="bt" name="bt" className="btn btn-secondary btn-sm" onClick={() => this.ListarFacturas(1)}><FontAwesomeIcon icon={faFilter} />&nbsp;&nbsp;Filtrar</button>
                                </div>
                            </div>
                            <br></br>
                            <div className="row">
                                <div className="col-xl-12">
                                    <table className="table table-hover table-condensed table-sm">
                                        <thead className="thead-inverse">
                                            <tr>
                                                <th className="align-middle">PACIENTE</th>
                                                <th className="align-middle">IDENTIFICACIÓN</th>
                                                <th className="align-middle">HISTORIA CLÍNICA</th>
                                                <th className="align-middle">TOTAL FACT.</th>
                                                <th className="align-middle">PAGADO</th>
                                                <th className="align-middle">SALDO PEND.</th>
                                                <th className="align-middle">ESTADO</th>
                                                <th className="align-middle">ACCIONES</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {load}
                                            {
                                                facturas.map((itemFacturas) => (
                                                    <tr key={itemFacturas.ID_FACTURA}>
                                                        <td>{itemFacturas.PACIENTE}</td>
                                                        <td>{itemFacturas.IDENTIFICACION}</td>
                                                        <td>{itemFacturas.ID_HISTORIA_CLINICA}</td>
                                                        <td><b>$ </b>{currencyFormat(itemFacturas.TOTAL_FACTURA)}</td>
                                                        <td><b>$ </b>{currencyFormat(itemFacturas.MONTO_PAGADO)}</td>
                                                        <td><b>$ </b>{currencyFormat(itemFacturas.SALDO_PENDIENTE)}</td>
                                                        <td>
                                                            {
                                                                itemFacturas.ESTADO === 2 ? (
                                                                    <span style={{ fontSize: 11, textTransform: 'uppercase' }} className="badge bg-warning">PENDIENTE</span>
                                                                ) : (
                                                                    <span style={{ fontSize: 11, textTransform: 'uppercase' }} className="badge bg-success">PAGADA</span>
                                                                )
                                                            }
                                                        </td>
                                                        <td>
                                                            <div className="btn-group" role="group" aria-label="">
                                                                <Link
                                                                    className="btn btn-primary btn-sm"
                                                                    to={"/UpFacturas/" + itemFacturas.ID_FACTURA}
                                                                >
                                                                    <FontAwesomeIcon icon={faHandHoldingUsd} />
                                                                </Link>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <nav aria-label="Page navigation example">
                                <ul className="pagination">
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarFacturas(1)}><FontAwesomeIcon icon={faAngleDoubleLeft} /></a></li>
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarFacturas(current - 1)}><FontAwesomeIcon icon={faAngleLeft} /></a></li>
                                    {(() => {
                                        let p = [];
                                        p.push(<li className="page-item" key={current}><a className="page-link" href="#" onClick={() => this.ListarFacturas(current)}>{current}</a></li>);
                                        return p;
                                    })()}
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarFacturas(current + 1)}><FontAwesomeIcon icon={faAngleRight} /></a></li>
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarFacturas(last)}><FontAwesomeIcon icon={faAngleDoubleRight} /></a></li>
                                </ul>
                            </nav>
                        </div>
                        <div className="card-footer text-muted">
                            <b>Página</b> <span className="badge bg-primary">{current}</span> <b>de</b> <span className="badge bg-primary">{last}</span> | <b>Registros</b> <span className="badge bg-success">{page}</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Listar;